import store1 from './store.js';
const store = store1;

const MESSAGES = {
	"error.encrypt.invalid.basic": "Username | Password are securely encrypted. To update your connection details, please re-enter your credentials.",
	"error.encrypt.invalid.api": "API Key is securely encrypted. To update your connection details, please re-enter your credentials.",
	"error.encrypt.invalid.oauth": "Client ID | Client secret are securely encrypted. To update your connection details, please re-enter your credentials.",
	"error.encrypt.invalid.oauthpassword": "Client ID | Username | Password are securely encrypted. To update your connection details, please re-enter your credentials.",
	"error.url.invalid": "Url must be a valid advanced URL",
	"error.application.duplicate.add": "Application cannot be created as name already exists",
	"error.application.duplicate.update": "Application cannot be updated as name already exists",
	"message.application.add": "Application added successfully",
	"message.application.update": "Application updated successfully",
	"error.name.required": "Name is required",
	"error.name.invalid": "Name must be valid",
	"error.maxLength.50": "Name is too long (maximum is 50 characters)",
	"error.maxLength.100": "Name is too long (maximum is 100 characters)",
	"error.process.duplicate.update": "Process cannot be updated as name already exists",
	"error.process.duplicate.add": "Process cannot be created as name already exists",
	"message.process.add": "Process added successfully",
	"message.process.update": "Process updated successfully",
	"error.name.length": "Name is too long (maximum is 50 characters)",
	"error.key.length": "Form key is too long (maximum is 50 characters)",
	"error.key.invalid": "Form key must be valid",
	"error.key.required": "Form key is required",
	"error.form.duplicate.name.add": "Form cannot be created as name already exists",
	"error.form.duplicate.name.update": "Form cannot be updated as name already exists",
	"error.tags.length": "Tag is too long (maximum is 50 characters)",
	"message.process.delete": "Process disabled successfully",
	"message.process.restore": "Process enabled successfully",
	"error.form.duplicate.key.add": "Form cannot be created as form key already exists",
	"error.processrequest": "Could not process your request",
	"message.form.add": "Form added successfully",
	"message.form.update": "Form updated successfully",
	"application.deployment.fail.link": "Application deployment failed.<br> <a class='table-link error-details-link'>Click here to see more details</a>",
	"application.deployment.fail": "Application deployment failed",
	"application.deployment.successful": "Application deployed successfully",
	"application.undeployment.successful": "Application undeployed successfully",
	"message.application.delete": " Application disabled successfully",
	"message.application.restore": "Application enabled successfully",
	"message.processlist.norecord": "No processes found",
	"message.tasklist.norecord": "No tasks found",
	"message.form.delete": "Form disabled successfully",
	"message.form.restore": "Form enabled successfully",
	"fileupload.maxsize": "Please select file with less than 10MB",
	"fileupload.scan.error": "File failed virus scan",
	"fileupload.exe.error": "Please upload valid file",
	"home.process.start.fail": "Process start failed",
	"home.process.start.fail.email": "Click here to email administrator(s)",
	"error.duplicate.labels": "Please enter unique tags",
	"customDataList.add.success": "Custom data list added successfully",
	"customDataList.update.success": "Custom data list updated successfully",
	"customDataList.add.duplicate": "Custom data list cannot be created as name already exists",
	"customDataList.update.duplicate": "Custom data list cannot be updated as name already exists",
	"customDataList.importDialog.testAdapter.success": "Adapter tested successfully",
	"customDataList.importDialog.testAdapter.error": "Error while calling service. Please check the validity of URL or URL query parameters",
	"application.form.submit.failure": "Task submission failed",
	"application.form.submit.failure.email": "Task submission failed.",
	"application.form.submit.failure.link": "<br> Click here to email administrator(s) for quick resolution",
	"application.form.submit.success": "Task completed successfully",
	"error.externalsystems.name": "Name is required",
	"error.externalsystems.description": "Description is required",
	"error.externalsystems.description.100": "Description is too long (maximum is 100 characters)",
	"error.description.invalid": "Description must be valid",
	"error.externalsystems.duplicate.add": "External system cannot be created as name already exists",
	"error.externalsystems.duplicate.update": "External system cannot be updated as name already exists",
	"message.externalSystem.update": "External system updated successfully",
	"message.externalSystem.add": "External system added successfully",
	"message.externalSystemAPI.update": "External system API updated successfully",
	"message.externalSystemAPI.add": "External system API added successfully",
	"error.externalsystemAPI.duplicate.add": "External system API cannot be created as name already exists",
	"error.externalsystemAPI.duplicate.update": "External system API cannot be updated as name already exists",
	"error.externalsystems.alias": "Default user name alias is required",
	"error.externalsystems.alias.max": "Default user name alias is too long (maximum is 50 characters)",
	"error.externalsystems.alias.invalid": "Default user name alias must be valid",
	"error.filename.required": "File name is required",
	"error.filename.length": "File name is too long (maximum is 50 characters)",
	"error.filename.invalid": "File name must be valid",
	"error.username.required": "Username is required",
	"error.username.length": "Username is too long (maximum is 255 characters)",
	"error.username.invalid": "Username must be valid",
	"error.email.required": "Email is required",
	"error.email.length": "Email is too long (maximum is 255 characters)",
	"error.email.invalid": "Email must be a valid email address",
	"fileadapters.message.update": "File adapter updated successfully",
	"fileadapters.message.add": "File adapter added successfully",
	"fileadapters.error.name.duplicate.add": "File adapter cannot be created as name already exists",
	"fileadapters.error.name.duplicate.update": "File adapter cannot be updated as name already exists",
	"error.externalSystemFileConnection.host": "Host is required",
	"host.maxLength.50": "Host is too long (maximum is 50 characters)",
	"error.externalSystemFileConnection.directory": "Directory is required",
	"domain.maxLength.50": "Domain is too long (maximum is 50 characters)",
	"username.maxLength.50": "Username is too long (maximum is 50 characters)",
	"error.externalSystemFileConnection.filepath": "File path is required",
	"error.externalSystemFileConnection.filepath.length": "File path is too long (maximum is 50 characters)",
	"error.externalSystemFileConnection.port": "Port must be greater than or equal to 0",
	"error.externalSystemFileConnection.port.max": "Port must be less than or equal to 65535",
	"password.maxLength.50": "Password is too long (maximum is 50 characters)",
	"error.externalSystemFileConnection.duplicate.add": "External system file connection cannot be created as name already exists",
	"error.externalSystemFileConnection.duplicate.update": "External system file connection cannot be updated as name already exists",
	"message.externalSystem.connection.add": "External system connection added successfully",
	"message.externalSystem.connection.update": "External system connection updated successfully",
	"message.externalSystem.connection.delete": "External system connection deleted successfully",
	"message.externalSystemFileConnection.connection.fail": "Test connection failed. Check that the details have been correctly specified",
	"message.externalSystemFileConnection.connection.success": "Test connection pass",
	"error.filepath.invalid": "File path must be valid",
	"host.invalid": "Host must be valid",
	"tasks.addAttachment.success": "Attachment added successfully",
	"tasks.addAttachment.error": "Error while adding attachment",
	"tasks.addAttachment.delete.error": "Error while deleting attachment",
	"tasks.addAttachment.delete.success": "Attachment deleted successfully",
	"application.form.claim.success": "Task claimed successfully",
	"application.form.unclaim.success": "Task unclaimed successfully",
	"application.form.delegate.success": "Task delegated successfully",
	"application.form.resolve.success": "Task resolved successfully",
	"application.form.claim.error ": "Error while claiming task",
	"application.form.unclaim.error ": "Error while unclaiming task",
	"application.form.delegate.error": "Error while delegating task",
	"application.form.resolve.error": "Error while resolving task",
	"application.form.reassign.success": "Task reassigned successfully",
	"application.form.reassign.error": "Error while reassigning task",
	"infoalert.task.claim.message": "This task cannot be claimed or unclaimed",
	"infoalert.claimed.task.reason": "Reason : It is claimed by",
	"infoalert.delegated.task.reason": "Reason : It is delegated to",
	"infoalert.deletedReason.reason": "Reason:",
	"tasks.involveUser.success": "User involved successfully",
	"tasks.involveUser.error.email": "User involved successfully. Error occurred while sending an email",
	"application.form.reassign.error.email": "Task reassigned successfully. Error occurred while sending an email",
	"application.form.delegate.error.email": "Task delegated successfully. Error occurred while sending an email",
	"tasks.involveUser.error": "Error while involving user",
	"error.processname.required": "Process name is required",
	"error.processname.invalid": "Process name must be valid",
	"error.processname.50": "Process name is too long (maximum is 50 characters)",
	"error.process.duplicatename.add": "Process name must be unique",
	"error.description.length": "Description is too long (maximum is 100 characters)",
	"error.description.length.150": "Description is too long (maximum is 150 characters)",
	"error.emailTemplate.duplicate.update": "Email template cannot be updated as name already exists",
	"error.emailTemplate.duplicate.add": "Email template cannot be created as name already exists",
	"message.emailTemplate.add": "Email template added successfully",
	"message.emailTemplate.update": "Email template updated successfully",
	"message.template.emailTemplate.delete": "Email template deleted successfully",
	"message.group.update": "Group updated successfully",
	"message.group.add": "Group added successfully",
	"error.group.duplicate.update": "Group cannot be updated as name already exists",
	"error.group.duplicate.add": "Group cannot be created as name already exists",
	"message.group.groupHierarchy.add": "Group added to hierarchy",
	"message.groupHierarchy.parent.update": "Parent changed successfully for group hierarchy",
	"error.group.description.maxlength": "Description is too long (maximum is 100 characters)",
	"message.group.disable": "Group disabled successfully",
	"message.group.enable": "Group enabled successfully",
	"error.group.in.hierarchy.and.has.child.groups": "Group cannot be disabled because it has child group within hierarchy",
	"tasks.addComment.sucess": "Comment added successfully",
	"tasks.addComment.failure": "Error while posting comment",
	"tasks.involveUser.delete.success": "User removed as participant successfully",
	"error.role.description.maxlength": "Description is too long (maximum is 255 characters)",
	"message.role.save": "Role updated successfully",
	"processVariables.page.save.success": "Custom view added successfully",
	"processVariables.page.update.success": "Custom view updated successfully",
	"processVariables.save.duplicate": "Custom view cannot be created as name already exists",
	"processVariables.update.duplicate": "Custom view cannot be updated as name already exists",
	"message.role.save.error": "Error while saving role",
	"tasks.involveUser.delete.error": "Error while removing user",
	"processVariables.page.delete.success": "Custom view deleted successfully",
	"import.multiplerequests": "Two requests are importing at the same time",
	"import.error": "error occured while importing",
	"processInstance.terminate.success": "Process terminated successfully",
	"processInstance.terminate.error": "Process terminated failed",
	"category.result.norecords": "No categories are available",
	"category.result.success": "Category data returned successfully",
	"message.category.update": "Category updated successfully",
	"message.category.add": "Category added successfully",
	"message.category.duplicate.name.add": "Category cannot be created as name already exists",
	"message.category.duplicate.name.update": "Category cannot be updated as name already exists",
	"message.category.remove.success": "Category deleted successfully",
	"message.category.remove.error": "Category cannot be deleted because it is associated with active process(es)",
	"message.category.remove.warning": "Category is associated with disabled / suspended process(es)",
	"message.category.update.warning": "Category is associated with disabled / suspended process(es). Are you sure you want to rename this category?",
	"message.category.requestError": "Could not process your request",
	"message.category.update.error": "Category name cannot be updated because it is associated with active process(es)",
	"emailTemplates.add.success": "System template added successfully",
	"emailTemplates.edit.success": "System template updated successfully",
	"emailTemplates.save.fail": "Error while saving system template",
	"message.process.copy.success": "Processes copied successfully",
	"message.process.copy.failure": "Error occurred while copying processes",
	"message.formTemplate.add": "Form template added successfully",
	"message.formTemplate.update": "Form template updated successfully",
	"error.formTemplate.duplicate.add": "Form template cannot be created as name already exists",
	"error.formTemplate.duplicate.update": " Form template cannot be updated as name already exists",
	"message.template.formTemplate.delete": "Form template deleted successfully",
	"error.dataField.required": "Data field is required",
	"error.valueField.required": "Value field is required",
	"error.value.required": "Value is required",
	"error.dataField.maxlength": "Data field is too long (maximum is 50 characters)",
	"error.valueField.maxlength": "Value field is too long (maximum is 100 characters)",
	"error.value.maxlength": "Value is too long (maximum is 100 characters)",
	"error.dataField.invalid": "Data field must be valid",
	"error.valueField.invalid": "Value field must be valid",
	"error.value.invalid": "Value must be valid",
	"error.dataField.unique": "Data field must be unique",
	"error.valueField.unique": "Value field must be unique",
	"error.externalsystemRestConnection.duplicate.add": "External system rest connection cannot be created as name already exists",
	"error.externalsystemRestConnection.duplicate.update": "External system rest connection cannot be updated as name already exists",
	"message.globalProcessProperties.update": "Global process properties updated successfully",
	"message.globalProcessProperties.add": "Global process properties added successfully",
	"message.globalProcessProperties.error.update": "Global process property cannot be updated as property name needs to be unique",
	"error.globalproperties.name": "Property name is required",
	"error.globalproperties.invalid": "Property name must be valid",
	"error.globalproperties.unique": "Property name must be unique",
	"error.globalproperties.50": "Property name is too long (maximum is 50 characters)",
	"message.correct.error": "Please correct the errors",
	"message.externalSystem.connection.fail": "Test connection failed. Check that the database details have been correctly specified",
	"message.externalSystem.connection.success": "Test connection pass",
	"error.externalsystems.sqlconnection.duplicate.add": "External system database connection cannot be created as name already exists",
	"error.globalproperties.value": "Property value is required",
	"error.globalproperties.value.invalid": "Property value must be valid",
	"error.globalproperties.value.100": "Property value is too long (maximum is 100 characters)",
	"error.externalsystems.sqlconnection.duplicate.update": "External system database connection cannot be updated as name already exists",
	"error.prefix.required": "Prefix is required",
	"error.prefix.length": "Prefix is too long (maximum is 50 characters)",
	"error.prefix.invalid": "Prefix must be valid",
	"error.sql.required": "SQL is required",
	"error.type.required": "Type is required",
	"sqladapters.delete.success": "Database adapter deleted successfully",
	"sqladapters.message.add": "Database adapter added successfully",
	"sqladapters.message.update": "Database adapter updated successfully",
	"sqladapters.sql.success": "Test sql successfull",
	"sqladapters.sql.success.nodata": "Test SQL successfull, no data found.",
	"sqladapters.error.sqlMethod": "Select at least one method",
	"sqladapters.sql.fail": "Test sql fail",
	"sqladapters.error.name.duplicate.add": "Database adapter cannot be created as name already exists",
	"sqladapters.error.name.duplicate.update": "Database adapter cannot be updated as name already exists",
	"error.user.duplicate.username.add": "User cannot be created as username already exists",
	"error.user.duplicate.email.add": "User cannot be created as email is associated with another user",
	"error.user.keyCloak.create": "Error occurred while creating user in keycloak",
	"error.user.sso.create": "Error occurred while creating user in Platform service",
	"message.user.add": "User added successfully",
	"message.user.update": "User updated successfully",
	"message.form.copy.failure": "Error occurred while copying forms",
	"message.form.copy.success": "Forms copied successfully",
	"error.form.duplicatename.add": "Form name must be unique",
	"error.form.duplicatekey.add": "Form key must be unique",
	"error.formcopy.duplicate.name.add": "Form cannot be created as form name already exists",
	"message.user.delete": "User disabled successfully",
	"message.user.restore": "User enabled successfully",
	"message.user.remove": "User removed successfully",
	"hierarchy.enable.success": "Group hierarchy enabled successfully",
	"hierarchy.disable.success": "Group hierarchy disabled successfully",
	"error.formcopy.name.required": "Form name is required",
	"error.formcopy.name.invalid": "Form name must be valid",
	"error.formcopy.maxLength.50": "Form name is too long (maximum is 50 characters)",
	"restadapters.message.update": "REST adapter updated successfully",
	"restadapters.message.add": "REST adapter added successfully",
	"restadapters.error.notFound": "No adapters Found",
	"restadapters.message.delete": "REST adapter deleted successfully",
	"restadapters.error.name.duplicate.add": "REST adapter cannot be created as name already exists",
	"restadapters.error.name.duplicate.update": "REST adapter cannot be updated as name already exists",
	"error.httpMethod.required": "Method is required",
	"error.urlSuffix.required": "Path is required",
	"error.groupHierarchy.duplicate.add": "Group hierarchy cannot be created as name already exists",
	"message.groupHierarchy.add": "Group hierarchy added successfully",
	"message.groupHierarchy.update": "Group hierarchy updated successfully",
	"adapter.test.servicerror": "Error while calling service. Please check the validity of URL or URL query parameters.",
	"error.description.required": "Description is required",
	"error.defaultValue.required": "Default value is required",
	"error.defaultValue.invalid": "Default value must be valid",
	"error.defaultValue.length": "Default value is too long (maximum is 50 characters)",
	"error.defaultDescription.required": "Default description is required",
	"error.defaultDescription.invalid": "Default description must be valid",
	"error.defaultDescription.length": "Default description is too long (maximum is 100 characters)",
	"error.options.empty": "At least one selection entry is mandatory",
	"error.options.value.required": "Value is required",
	"error.options.description.required": "Description is required",
	"error.options.value.length": "Value is too long (maximum is 50 characters)",
	"error.options.description.length": "Description is too long (maximum is 100 characters)",
	"error.duplicate.userProperty.create.name": "User property cannot be created as name already exists",
	"error.save.partialFormData": "Error while saving draft",
	"error.update.partialFormData": "Error while updating draft",
	"error.duplicate.userProperty.update.name": "User property cannot be updated as name already exists",
	"error.defaultAlias.required": "Default user name alias is required",
	"error.defaultAlias.invalid": "Default user name alias must be valid",
	"error.defaultAlias.length": "Default user name alias is too long (maximum is 50 characters)",
	"message.userProperty.add": "User property added successfully",
	"message.userProperty.update": "User property updated successfully",
	"message.userProperty.delete": "User property deleted successfully",
	"error.user.in.active.business.process": "This is the only user belonging to a group used in an active business process.",
	"message.group.groupHierarchy.delete": "Group removed from hierarchy",
	"message.settings.update": " Properties updated successfully",
	"message.settings.update.error": "Error updating properties",
	"error.description.maxlength": "Description is too long (maximum is 100 characters)",
	"error.value.maxlength.50": "Value is too long (maximum is 50 characters)",
	"error.value.unique": "Value must be unique",
	"error.description.unique": "Description must be unique",
	"message.themes.update": "Theme updated successfully",
	"message.themes.logo.notallowed.file.msg": "Invalid file type. Please upload only .jpeg, .jpg, .png, .svg or .bmp files",
	"message.themes.logo.size.exceeded.file.msg": "File size exceeded. Allowed size is 500 KB",
	"message.themes.favicon.notallowed.file.msg": "Invalid file type. Please upload only .jpeg, .jpg, .png, .ico or .bmp files.",
	"message.removeLogo.success": "Logo removed successfully",
	"message.removefavicon.success": "Favicon removed successfully",
	"error.name.unique": "Name must be unique",
	"processerror.delete.success": "Process error deleted successfully",
	"error.input.owasp.error": "Tags must be valid",
	"error.forbidden": "Error occured while saving form",
	"task.draft.save.success": "Draft saved successfully under My Tasks > Drafts",
	"task.draft.save.success.standalone": "Draft saved successfully",
	"process.draft.save.success": "Draft saved successfully under My Processes > Drafts",
	"process.draft.save.success.standalone": "Draft saved successfully",
	"draft.delete.success": "Draft deleted successfully",
	"license.name.required": "Organisation name is required",
	"license.name.invalid": "Organisation name must be valid",
	"license.name.length": "Organisation name is too long (maximum is 255 characters)",
	"license.email.required": "Organisation email is required",
	"license.email.invalid": "Organisation email must be a valid email address",
	"license.email.length": "Organisation email is too long (maximum is 255 characters)",
	"license.applications.required": "Number of applications is required",
	"license.applications.invalid": "Number of applications must be less than or equal to 999999999",
	"error.license.key": "Error while generating license key",
	"license.key.success": "License key copied to clipboard",
	"license.key.invalid": "License key is invalid",
	"license.key.required": "License key is required",
	"error.license.update.success": "License information updated successfully",
	"error.license.key.invalidname": "Organisation name does not match with provided licence key",
	"error.license.key.invalidemail": "Organisation email does not match with provided licence key",
	"error.license.key.empty": "License key is required",
	"license.key.notprovided": "License key is not provided. You are allowed to deploy only one application.",
	"license.expired.message": "The maximum number of deployments has now been reached. Please enquire about extending your licence if more application deployments are required.",
	"error.application.notFound": "Application not found",
	"error.undeploy.application": "Error while undeploying application", 
	"error.externalsystems.readonly":"You cannot edit read-only external system, please contact your system administrator.",
	"customView.share.update.success":"Custom view sharing updated successfully",
	"error.process.deployment":"No form is attached to the start event",
	"formDesigner.dialog.autoSave.update.success": "Auto save data updated successfully"
};

const DISPLAY_NAME = {
	"settings.systemAdminFailureGroups.displayName": "System admin failure groups",
	"settings.sendEmailNotification.displayName": "Task email notification",
	"settings.user.task.email.default.message": "Default email message for user task",
	"settings.enablePrivacyPolicy.displayName": "Enable privacy policy",
	"settings.privacyPolicyLinkName.displayName": "Privacy policy link name",
	"settings.privacyPolicyLinkUrl.displayName": "Privacy policy link URL",
	"settings.googleKey.displayName": "Google map key",
	"settings.bingKey.displayName": "Bing map key",
	"settings.helpURL.displayName": "Help URL",
	"settings.enableClamAV.displayName": "Enable clamAV",
	"settings.clamAVHost.displayName": "ClamAV host",
	"settings.clamAVPort.displayName": "ClamAV port",
	"recaptcha.key": "Recaptcha key",
	"recaptcha.secretKey": "Recaptcha secret key",
	"license.key": "Licence key",
	"settings.flowable.mail.server.host.displayName": "Mail host",
	"settings.flowable.mail.server.port.displayName": "Mail port",
	"settings.flowable.mail.server.username.displayName": "Mail username",
	"settings.flowable.mail.server.password.displayName": "Mail password",
	"settings.flowable.mail.server.default-from.displayName": "Mail default from",
	"settings.flowable.mail.server.use-tls.displayName": "Mail use-TLS",
	"settings.flowable.mail.server.use-ssl.displayName": "Mail use-SSL",
	"settings.flowable.mail.server.credential":"Mail credentials"
};

const URL_UTILS = {
	root_url: store.getters.getHelpUrl,
	updateRootUrl(url) {
		this.root_url = url;
	},
	getBreadCrumbHelp() {
		return {
			"application.create": {
				'title': "Create a new application.",
				'url': this.root_url + 'design%2Fapplications.htm%23Adding_Applications'
			},
			"application.list": {
				'title': "View all applications and/or add a new application. Applications are the containers for business processes and user forms. Use the filter to find specific applications.",
				'url': this.root_url + 'design%2Fapplications.htm'
			},
			"myProcesses.allInvolved": {
				'title': "View all processes that involve(d) you. Use the filter to find specific processes.",
				'url': this.root_url + 'My_Processes%2FMy_Processes.htm'
			},
			"myProcesses.startedByMe": {
				'title': "View all processes that you have started. Use the filter to find specific processes.",
				'url': this.root_url + 'My_Processes%2FMy_Processes.htm'
			},
			"myProcesses.drafts": {
				'title': "View all drafts that are saved/updated by you.",
				'url': this.root_url + 'My_Processes%2FMy_Processes.htm'
			},
			"application.process.create": {
				'title': "Create a new business process.",
				'url': this.root_url + 'design%2Fapplications.htm%23Processes'
			},
			"application.process.copy": {
				'title': "Copy business process.",
				'url': this.root_url + 'design%2Fapplications.htm%23Processes'
			},
			"application.form.edit": {
				'title': "View and edit user form details and add/edit the form design.",
				'url': this.root_url + 'design%2Fapplications.htm%23Forms'
			},
			"mytasks.assigned": {
				'title': "View all tasks that are assigned to you. Use the filter to find specific tasks.",
				'url': this.root_url + 'tasks%2Fmy_tasks.htm'
			},
			"mytasks.unclaimed": {
				'title': "View all tasks that are unclaimed. Use the filter to find specific tasks.",
				'url': this.root_url + 'tasks%2Fmy_tasks.htm'
			},
			"mytasks.involved": {
				'title': "View all tasks that involve(d) you. Use the filter to find specific tasks.",
				'url': this.root_url + 'tasks%2Fmy_tasks.htm'
			},
			"mytasks.draftTasks": {
				'title': "View all drafts that are saved/updated by you.",
				'url': this.root_url + 'tasks%2Fmy_tasks.htm'
			},
			"application.edit": {
				'title': 'View and edit application details, add new business processes, user forms and deploy the application.',
				'url': this.root_url + 'design%2Fapplications.htm%23Editing_Applications'
			},
			"application.copy": {
				'title': 'Copy an application.',
				'url': this.root_url + 'design%2Fapplications.htm%23Adding_Applications'
			},
			"application.process.edit": {
				'title': 'View and edit business process details and add/edit the process model diagram.',
				'url': this.root_url + 'design%2Fapplications.htm%23Processes'
			},
			"application.form.create": {
				'title': 'Create a new user form.',
				'url': this.root_url + 'design%2Fapplications.htm%23Forms'
			},
			"application.form.copy": {
				'title': 'Copy user form(s).',
				'url': this.root_url + 'design%2Fapplications.htm%23Forms'
			},
			"application.process.list": {
				'title': "View all business process details. Use the filter to find specific business processes.",
				'url': this.root_url + 'design%2Fprocesses.htm'
			},
			"design.customdatalist.list": {
				'title': "View custom data lists and/or add a new custom data list. Use the filter to find specific custom data lists.",
				'url': this.root_url + 'design%2FCustom_Data_List.htm'
			},
			"design.customdatalist.edit": {
				'title': "View and edit custom data list details.",
				'url': this.root_url + 'design%2FCustom_Data_List.htm'
			},
			"design.customdatalist.create": {
				'title': "Create a new custom data list.",
				'url': this.root_url + 'design%2FCustom_Data_List.htm'
			},
			"design.categories.edit": {
				'title': "Group similar or related processes into categories so users can find what they want more easily.",
				'url': this.root_url + 'design%2Fprocess_categories.htm'
			},
			"application.form.list": {
				'title': "View all user form details. Use the filter to find specific forms.",
				'url': this.root_url + 'design%2Fforms.htm'
			},
			"processengine.processdefinitions.list": {
				'title': "View all process definition. Use the filter to find specific process definition.",
				'url': this.root_url + 'process_engine%2Fdefinitions.htm'
			},
			"processengine.processdefinitions.edit": {
				'title': "View process definition details.",
				'url': this.root_url + 'process_engine%2Fdefinitions.htm%23View_Definitions'
			},
			"processengine.tasks.list": {
				'title': "View all tasks. Use the filter to find specific tasks.",
				'url': this.root_url + 'process_engine%2Ftasks.htm'
			},
			"processengine.tasks.customView.create": {
				'title': "Create a new custom view.",
				'url': this.root_url + 'process_engine%2Ftasks.htm'
			},
			"processengine.tasks.customView.edit": {
				'title': "View and edit custom view details, add/remove process variables.",
				'url': this.root_url + 'process_engine%2Ftasks.htm'
			},
			"processengine.processes.customView.create": {
				'title': "Create a new custom view.",
				'url': this.root_url + 'process_engine%2Finstances.htm'
			},
			"processengine.processes.customView.edit": {
				'title': "View and edit custom view details, add/remove process variables.",
				'url': this.root_url + 'process_engine%2Finstances.htm'
			},
			"processengine.instances.list": {
				'title': "View all process instances. Use the filter to find specific process instances.",
				'url': this.root_url + 'process_engine%2Finstances.htm'
			},
			"processengine.instances.view": {
				'title': "View process instance details.",
				'url': this.root_url + 'process_engine%2Finstances.htm%23Viewing_Processes'
			},
			"roles.list": {
				'title': "View all roles and composite roles for those roles. Click particular role to find specific role details.",
				'url': this.root_url + 'users_and_groups%2Froles.htm'
			},
			"externalsystems.list": {
				'title': "View all external systems and/or add a new external system.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm'
			},
			"formtemplates.list": {
				'title': "View form templates and/or add a new form template. Templates can be used as a starting point when designing a new form in a business process.",
				'url': this.root_url + 'design%2FForm_Templates.htm'
			},
			"emailtemplates.list": {
				'title': "View e-mail templates and/or add a new email template. Templates can be used as a starting point when designing emails within a business process.",
				'url': this.root_url + 'design%2FEmail_Templates.htm'
			},
			"emailtemplates.create": {
				'title': "Create a new e-mail template.",
				'url': this.root_url + 'design%2FEmail_Templates.htm'
			},
			"emailtemplates.copy": {
				'title': "Copy e-mail template.",
				'url': this.root_url + 'design%2FEmail_Templates.htm'
			},
			"emailtemplates.edit": {
				'title': "View and edit email template details.",
				'url': this.root_url + 'design%2FEmail_Templates.htm'
			},
			"groups.list": {
				'title': " View all groups and/or add a new group. Use the filter to find specific groups.",
				'url': this.root_url + 'users_and_groups%2Fgroups.htm'
			},
			"usersgroups.hierarchies.list": {
				'title': "View all group hierarchies and/or add a new hierarchy. Use the filter to find specific hierarchies.",
				'url': this.root_url + 'users_and_groups%2Fhierarchies.htm'
			},
			"usersgroups.userproperties.list": {
				'title': "View all user property definitions and/or add a new property.",
				'url': this.root_url + 'users_and_groups%2Fuser_properties.htm'
			},
			"usersgroups.userproperties.create": {
				'title': "Create a new user property.",
				'url': this.root_url + 'users_and_groups%2Fuser_properties.htm%23Adding_a_User_Property'
			},
			"usersgroups.userproperties.edit": {
				'title': "View and edit user property definition.",
				'url': this.root_url + 'users_and_groups%2Fuser_properties.htm%23Editing_a_User_Property'
			},
			"usersgroups.users.list": {
				'title': "View all users and/or add a new user. Use the filter to find specific users.",
				'url': this.root_url + 'users_and_groups%2Fusers.htm'
			},
			"usersgroups.users.edit": {
				'title': "View and edit user details, properties, groups, external system mappings and roles.",
				'url': this.root_url + 'users_and_groups%2Fusers.htm%23Editing_Users'
			},
			"user.profile": {
				'title': "View your personal profile details.",
				'url': this.root_url + 'administration%2Fuser_profile.htm'
			},
			"externalsystem.create": {
				'title': "Create a new external system.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Adding_an_External_System'
			},
			"externalsystem.edit": {
				'title': "View and edit external system details and/or add a new API.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Editing_External_Systems'
			}, "externalsystemAPI.create": {
				'title': "Create a new API for this external system.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Adding_API_s'
			}, "externalsystemAPI.edit": {
				'title': "View and edit REST/Database/File API details and/or add a new connection/adapter(s).",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Editing_API_s'
			},
			"tasks.view": {
				'title': " View task details",
				'url': this.root_url + 'tasks%2Fmy_tasks.htm%23Viewing_Tasks'
			},
			"processengine.processerrors.list": {
				'title': "View all process errors and/or delete process error. Use the filter to find specific process error.",
				'url': this.root_url + 'process_engine%2Fprocess_errors.htm'
			},
			"processengine.job.list": {
				'title': "View all jobs. Use the filter to find specific jobs.",
				'url': this.root_url + 'process_engine%2Fjobs.htm'
			},
			"processengine.job.edit": {
				'title': "View job details.",
				'url': this.root_url + 'process_engine%2Fjobs.htm%23Viewing_Process_Jobs'
			},
			"fileadapter.create": {
				'title': "Create a new file adapter. ",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23REST_Adapters'
			},
			"fileadapter.edit": {
				'title': "View and edit file adapter details.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23REST_Adapters'
			},
			"sqladapter.create": {
				'title': "Create a new database adapter.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23REST_Adapters'
			},
			"sqladapter.edit": {
				'title': "View and edit database adapter details.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23REST_Adapters'
			},
			"restadapter.create": {
				'title': "Create a new REST adapter.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23REST_Adapters'
			},
			"restadapter.edit": {
				'title': "View and edit REST adapter details.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23REST_Adapters'
			},
			"fileconnection.create": {
				'title': "Create a new file connection.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Adding_and_Testing_Connections'
			}, "fileconnection.edit": {
				'title': "View and edit file connection details.",
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Adding_and_Testing_Connections'
			},
			"administration.audithistory.list": {
				'title': "View changes made throughout the system. Use the filter to find specific changes. This screen does not show the history of business processes.",
				'url': this.root_url + 'administration%2Faudit_history.htm'
			},
			"administration.audithistory.revision.detail": {
				'title': "View details of all entities added, modified and removed in an individual revision.",
				'url': this.root_url + 'administration%2Faudit_history.htm%23Filtering_Users'
			},
			"administration.audithistory.entity": {
				'title': "View a full history of all changes for a specific entity type. Use the filter to find specific changes.",
				'url': this.root_url + 'administration%2Faudit_history.htm%23Sorting_Users'
			}
			, "group.create": {
				'title': "Create a new group.",
				'url': this.root_url + 'users_and_groups%2Fgroups.htm%23Adding_Groups'
			}, "group.edit": {
				'title': "View and edit group details and add/remove users.",
				'url': this.root_url + 'users_and_groups%2Fgroups.htm%23Editing_Groups'
			}, "role.edit": {
				'title': "View and edit role details and add/remove users.",
				'url': this.root_url + 'users_and_groups%2Froles.htm%23Editing_a_Role'
			},
			'importexport': {
				'title': 'Export and/or import data from the system. This can be useful when moving data between systems',
				'url': this.root_url + 'administration%2Fimport_export.htm'
			}, 'deployment.list': {
				'title': 'View all deployments. Use the filter to find specific deployment.',
				'url': this.root_url + 'process_engine%2Fdeployment.htm'
			}, 'deployment.edit': {
				'title': ' View deployments.',
				'url': this.root_url + 'process_engine%2Fdeployment.htm%23Viewing_Process_Deployments'
			}, 'globalprocessprops': {
				'title': ' View and edit global process properties details.',
				'url': this.root_url + 'design%2Fglobal_process_properties.htm'
			}, 'usersgroups.users.import': {
				'title': 'Import users from keycloak, Use the filter to find specific type of users.',
				'url': this.root_url + 'users_and_groups%2Fusers.htm%23Importing_Users'
			}, 'admin.systemtemplates': {
				'title': 'View and edit system templates for tasks.',
				'url': this.root_url + 'administration%2FSystem_Templates.htm'
			},
			"formtemplates.create": {
				'title': "Create a new form template.",
				'url': this.root_url + 'design%2FForm_Templates.htm'
			},
			"formtemplates.copy": {
				'title': "Copy form template.",
				'url': this.root_url + 'design%2FForm_Templates.htm'
			},
			"formtemplates.edit": {
				'title': " View and edit form template details.",
				'url': this.root_url + 'design%2FForm_Templates.htm'
			},
			'design.processes.copy': {
				'title': 'Copy business process(es) details.',
				'url': this.root_url + 'design%2Fapplications.htm%23Processes'
			},
			"externalSystemConnection.Rest.edit": {
				'title': 'View and edit REST connection details.',
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Editing_Connections'
			},
			"externalSystemConnection.Rest.Create": {
				'title': 'Create a new REST connection.',
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Adding_and_Testing_Connections'
			},
			"externalSystemConnection.database.edit": {
				'title': 'View and edit database connection details.',
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Editing_Connections'
			},
			"externalSystemConnection.database.Create": {
				'title': 'Create a new database connection.',
				'url': this.root_url + 'integrate%2Fexternal_system.htm%23Adding_and_Testing_Connections'
			},
			"hierarchy.edit": {
				'title': 'View and edit hierarchy details and organise the hierarchy.',
				'url': this.root_url + 'users_and_groups%2Fhierarchies.htm%23Editing_Hierarchies'
			},
			"hierarchy.create": {
				'title': 'Create a new group hierarchy.',
				'url': this.root_url + 'users_and_groups%2Fhierarchies.htm%23Editing_Hierarchies'
			},
			"admin.settings": {
				'title': 'View and edit general system settings.',
				'url': this.root_url + 'administration%2Fsettings.htm'
			},
			"admin.themes": {
				'title': ' View and edit theme settings.',
				'url': this.root_url + 'administration%2Fthemes.htm'
			},
			"admin.dashboard": {
				'title': 'View the current system status and usage. Drill down from the charts to view detailed information.',
				'url': this.root_url + 'administration%2Fdashboard.htm'
			},
			"user.dashboard": {
				'title': 'View the current system status and usage. Drill down from the charts to view detailed information.',
				'url': this.root_url + 'administration%2Fdashboard.htm'
			}, "license.create": {
				'title': "View and add/edit current licence details.",
				'url': this.root_url + 'administration%2Flicence_management.htm'
			}
		};
	}
};

var BREADCRUMB_HELP = URL_UTILS.getBreadCrumbHelp();

const PATTERNS = {
	name: '^[A-Za-z0-9\\-]+(?: +[A-Za-z0-9\\-]+)*$', // Used in Names - Text input
	customName: '^[A-Za-z0-9\\-]+(?: +[A-Za-z0-9\\-]+)*$', // used in custom view name field
	description: '^[\\-\\(\\)a-zA-Z0-9.]+(?: +[\\-\\(\\)a-zA-Z0-9.]+)*$', // Used in Description textareas
	disableReason: "^[a-zA-Z0-9\\-.@#!%^()_+|~=`:;?,]+(?: +[a-zA-Z0-9\\-.@#!%^()_+|~=`:;?,]+)*$",
	nameWithoutSpaces: '^[A-Za-z0-9]*$', // Form Key
	helpDocumentationES: '^[a-zA-Z0-9.+:\\/\\-]*$', //
	suffixURL: '^[a-zA-Z0-9$\\-_.+!*\'(){},;\/?:@=&%\\[\\]#]*$',
	jdbcURL: '^[@:a-zA-Z0-9.\\-\/=;]*$',
	usernameFilter: "^[a-zA-Z0-9\\-.\\\\@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,]+(?: +[a-zA-Z0-9\\-.\\\\@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,]+)*$",
	username: "^[a-zA-Z0-9\\-.@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,]+(?: +[a-zA-Z0-9\\-.@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,]+)*$",
	settingValue: "^[a-zA-Z0-9\\-.@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,\/]+(?: +[a-zA-Z0-9\\-.@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,\/]+)*$",
	mailPassword: "^[a-zA-Z0-9\\-.@#!$%^&*()_+|~=`{}\\[\\]:&quot;'?,\/]+(?: +[a-zA-Z0-9\\-.@#!$%^&*()_+|~=`{}\\[\\]:&quot;'?,\/]+)*$",
	filePath: "^[a-zA-Z0-9\\-.@#!$%^&()_+~=`{};',\/]+(?: +[a-zA-Z0-9\\-.@#!$%^&()_+~=`{};',\/]+)*$",
	strapline: '^[\\-\\(\\)a-zA-Z0-9\\,\\.]+(?: +[\\-\\(\\)a-zA-Z0-9\\,\\.]+)*$',
	usernameFilter: "^[a-zA-Z0-9\\-.\\\\@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,]+(?: +[a-zA-Z0-9\\-.\\\\@#!$%^&()_+|~=`{}\\[\\]:&quot;'?,]+)*$",
	email: "^[a-zA-Z0-9._\\-]+@[a-zA-Z0-9.\\-]+\.[a-zA-Z]{2,4}$",
	properties_name: "^[a-zA-Z0-9]+(?: +[a-zA-Z0-9]+)*$"
}

const PAGEHEADER_TITLE = {
	"menu.design.applications": "Applications",
	"menu.design.applications.create": "Application details - Create new",
	"menu.design.categories": "Categories",
	"menu.design.globalProperties": "Global process properties",
	"menu.design.processes": "Processes",
	"menu.design.processes.create": "Process details - Create new",
	"menu.design.forms": "Forms",
	"menu.design.forms.create": "Form details - Create new",
	"menu.design.emailTemplates": "Email templates",
	"menu.design.emailTemplates.create": "Email template details - Create new",
	"menu.design.formTemplates": "Form templates",
	"menu.design.formTemplates.create": "Form template details - Create new",
	"menu.design.dataList": "Custom data list",
	"menu.design.dataList.create": "Custom data list - Create new",
	"menu.processes.startedByMe": "Started by me",
	"menu.processes.allInvolved": "All involved",
	"menu.processes.instances": "Process instance",
	"menu.tasks.assigned": "Assigned",
	"menu.tasks.unclaimed": "Unclaimed",
	"menu.tasks.allInvolved": "All involved",
	"menu.tasks.draftTask": "Drafts",
	"menu.processes.draftProcess": "Drafts",
	"menu.admin.dashboard": "Dashboard",
	"menu.admin.impexp": "Import/Export details",
	"menu.admin.sysTemplates": "System template details",
	"menu.admin.auditHist": "Audit history",
	"menu.admin.entityHist": "Entity history",
	"menu.admin.revision": "Revision",
	"menu.admin.settings": "Settings",
	"menu.admin.themes": "Themes",
	"menu.admin.monitor": "Monitor application",
	"menu.usergroups.users": "Users",
	"menu.usergroups.users.import": "Users - Import users",
	"menu.usergroups.userProps": "User properties",
	"menu.usergroups.userPropCreate": "User property details - Create new",
	"menu.usergroups.groups": "Groups",
	"menu.usergroups.hierarchies": "Group hierarchies",
	"menu.usergroups.hierarchyCreate": "Hierarchy details - Create new",
	"menu.usergroups.roles": "Roles",
	"menu.integrate.externalSysList": "External systems",
	"menu.integrate.externalSysCreate": "External system details - Create new",
	"menu.integrate.fileConn": "External system file connection",
	"menu.integrate.fileConn.create": "External system file connection - Create new",
	"menu.integrate.fileAdapter": "External system file adapter",
	"menu.integrate.fileAdapter.create": "External system file adapter - Create new",
	"menu.integrate.restConn": "External system REST connection",
	"menu.integrate.restConn.create": "External system REST connection - Create new",
	"menu.integrate.restAdapter": "External system REST adapter",
	"menu.integrate.restAdapter.create": "External system REST adapter - Create new",
	"menu.integrate.dbConn": "External system DB connection",
	"menu.integrate.dbConn.create": "External system DB connection - Create new",
	"menu.integrate.sqlAdapter": "External system SQL adapter",
	"menu.integrate.sqlAdapter.create": "External system SQL adapter - Create new",
	"menu.process.engine.deployments": "Deployments",
	"menu.process.engine.deployment.details": "Deployments details",
	"menu.process.engine.definations": "Definations",
	"menu.process.engine.defination.details": "Process definition details",
	"menu.process.engine.instances": "Instances",
	"menu.process.engine.instance.create": "Custom view details - Create new",
	"menu.process.engine.tasks": "Tasks",
	"menu.process.engine.task.create": "Custom view details - Create new",
	"menu.process.engine.task.edit": "Tasks",
	"menu.process.engine.jobs": "Jobs",
	"menu.process.engine.errors": "Process errors",
	"menu.user.profile": "User profile",
	"menu.user.dashboard": "Dashboard",

	"menu.revision.details": "Revision details",
	"menu.application.details": "Application details",
	"menu.form.details": "Form details",
	"menu.process.details": "Process details",
	"menu.emailTemplate.details": "Email template details",
	"menu.formTemplate.details": "Form template details",
	"menu.systemconnection.details": "External system connection",
	"menu.systemApi.details": "External system API",
	"menu.externalsystem.details": "External system details",
	"menu.fileadapter.details": "File adapter",
	"menu.fileconnection.details": "File connection",
	"menu.restadapter.details": "REST adapter",
	"menu.databaseadapter.details": "Database adapter",
	"menu.processdefination.details": "Process definition details",
	"menu.deployment.details": "Deployment details",
	"menu.customview.details": "Custom view details",
	"menu.job.details": "Job details",
	"menu.group.details": "Group details",
	"menu.hierarchy.details": "Hierarchy details",
	"menu.role.details": "Role details",
	"menu.userproperty.details": "User property details",
	"menu.user.details": "User details",
}

export default Object({
	MESSAGES,
	BREADCRUMB_HELP,
	PATTERNS,
	DISPLAY_NAME,
	URL_UTILS,
	PAGEHEADER_TITLE
});
